/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, Space, Table } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useState, useEffect } from "react";

import CreateEditBulkEmailingSendersModal from "./CreateEditSenderModal";
import { showErrorNotification } from "../../../../utils/notification";

const ConfigureBulkEmailingSendersModal = ({
  ROOT_URL,
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const TARGET_URL = "admin/bulk-notifications/senders";

  const [sendersList, setSendersList] = useState([]);
  const [currentSenderId, setCurrentSenderId] = useState();

  const [isCreateEditModalOpen, setIsCreateEditModalOpen] = useState(false);
  const [currentSenderDetails, setCurrentSenderDetails] = useState({});

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const resetCurrentSenderDetails = () => {
    setCurrentSenderId("");
    setCurrentSenderDetails({});
  };

  const fetchBulkEmailingSenders = () => {
    axios
      .get(`${ROOT_URL}/${TARGET_URL}/list`, {})
      .then((res) => {
        const { sendersList = [] } = res.data;
        setSendersList(sendersList);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleCreateEditEmailSender = (createOrUpdateParams) => {
    if (currentSenderId?.length > 0) {
      axios
        .post(`${ROOT_URL}/${TARGET_URL}/update`, {
          senderId: currentSenderId,
          updatedSenderParams: createOrUpdateParams
        })
        .then(() => {
          setIsCreateEditModalOpen(false);
          resetCurrentSenderDetails();
          fetchBulkEmailingSenders();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    } else {
      axios
        .post(`${ROOT_URL}/${TARGET_URL}/create`, {
          newSenderParams: createOrUpdateParams
        })
        .then(() => {
          setIsCreateEditModalOpen(false);
          resetCurrentSenderDetails();
          fetchBulkEmailingSenders();
        })
        .catch((err) => {
          showErrorNotification(err);
        });
    }
  };

  const sendersListColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => {
        if (typeof a.name === "string" && typeof b.name === "string") {
          return a.name?.localeCompare(b.name) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
      sorter: (a, b) => {
        if (typeof a.name === "string" && typeof b.name === "string") {
          return a.name?.localeCompare(b.name) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Backend Key",
      dataIndex: "backendKey",
      key: "backendKey",
      sorter: (a, b) => {
        if (typeof a.name === "string" && typeof b.name === "string") {
          return a.name?.localeCompare(b.name) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy"
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => dayjs(createdAt).format("DD MMM YYYY | HH:mm")
    },
    {
      title: "Actions",
      key: "action",
      render: (row) => (
        <div
          id="bulk_notification_senders_actions"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around"
          }}
        >
          <Space wrap>
            <>
              <Button
                type="primary"
                onClick={() => {
                  setCurrentSenderId(row.key);
                  setCurrentSenderDetails(row);
                  setIsCreateEditModalOpen(true);
                }}
              >
                Update
              </Button>
            </>
          </Space>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchBulkEmailingSenders();
  }, []);

  return (
    <Modal
      title="Manage Senders"
      open={isModalOpen}
      footer={[]}
      width="1500px"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginBottom: "10px"
        }}
      >
        <Button
          type="primary"
          onClick={() => {
            resetCurrentSenderDetails();
            setIsCreateEditModalOpen(true);
          }}
        >
          Create New Sender
        </Button>
      </div>
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "5px"
        }}
      >
        <h3>Senders</h3>
        <Table
          columns={sendersListColumns}
          dataSource={sendersList}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }}
        />
      </div>
      {isCreateEditModalOpen && (
        <CreateEditBulkEmailingSendersModal
          initialValues={currentSenderDetails}
          isModalOpen={isCreateEditModalOpen}
          setIsModalOpen={setIsCreateEditModalOpen}
          handleSenderCreateEdit={handleCreateEditEmailSender}
        />
      )}
    </Modal>
  );
};
export default ConfigureBulkEmailingSendersModal;
